import { useState, useEffect } from 'react';
import { testimonials } from '../utils/dataModel';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-rotate testimonials every 8 seconds
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    // Resume auto-play after 15 seconds of user interaction
    setTimeout(() => setIsAutoPlaying(true), 15000);
  };

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 15000);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 15000);
  };

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">
        <h2 className="section-title">What Our Clients Say</h2>
        
        <div className="testimonials-carousel">
          <button 
            className="carousel-button carousel-button-prev" 
            onClick={prevTestimonial}
            aria-label="Previous testimonial"
          >
            ‹
          </button>

          <div className="testimonial-carousel-card">
            <div className="testimonial-carousel-content">
              <p className="testimonial-carousel-body">"{currentTestimonial.body}"</p>
            </div>
            <div className="testimonial-carousel-author">
              <img 
                src={currentTestimonial.picture} 
                alt={currentTestimonial.name}
                className="testimonial-carousel-picture"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <div className="testimonial-carousel-info">
                <p className="testimonial-carousel-name">{currentTestimonial.name}</p>
                <p className="testimonial-carousel-title">{currentTestimonial.title}</p>
              </div>
            </div>
          </div>

          <button 
            className="carousel-button carousel-button-next" 
            onClick={nextTestimonial}
            aria-label="Next testimonial"
          >
            ›
          </button>
        </div>

        <div className="carousel-indicators">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToTestimonial(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
